var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320915"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 629",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 13C18.7908 13 17 14.7909 17 17C17 19.2091 18.7908 21 21 21C23.2092 21 25 19.2091 25 17C25 14.7909 23.2092 13 21 13Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3232 23.7011C24.0568 21.433 18.943 21.433 14.6767 23.7011C14.2603 23.9225 14 24.3558 14 24.8275V27.6533C14 28.3971 14.6027 29 15.3462 29H27.6538C28.3973 29 29 28.3971 29 27.6533V24.8275C29 24.3558 28.7396 23.9225 28.3232 23.7011Z",
    fill: "#686868"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImage);
export default __webpack_public_path__ + "static/media/user_image.94d8f946bfcdd4cc691d95c5534eccf0.svg";
export { ForwardRef as ReactComponent };